import { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "~/components/ui";
import { routes } from "~/lib/constants";
import { useSelector } from "~/redux/store";

const timeout = 900_000;
// const timeout = 100_000;
const promptBeforeIdle = 60_000;
const SessionTimeout = () => {
  const userId = useSelector((state) => state.persistedReducer.auth.userId);
  const navigate = useNavigate();
  //   const [state, setState] = useState("Active");
  const [remaining, setRemaining] = useState(timeout);
  const [isOpen, setIsOpen] = useState(false);

  const onIdle = () => {
    // setState("Idle");
    setIsOpen(false);
    navigate(routes.logout());
  };

  const onActive = () => {
    // setState("Active");
    setIsOpen(false);
  };

  const onPrompt = () => {
    // setState("Prompted");
    setIsOpen(true);
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
    disabled: !userId,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  });
  const handleStillHere = () => {
    activate();
    setIsOpen(false);
  };

  //   const timeTillPrompt = Math.max(remaining - promptBeforeIdle / 1000, 0);
  //   const seconds = timeTillPrompt > 1 ? "seconds" : "second";
  return (
    <div>
      <Dialog
        open={isOpen}
        onOpenChange={() => {
          handleStillHere();
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Session Timeout</DialogTitle>
          </DialogHeader>
          <div className="px-3 pb-6">
            <div className="flex flex-col items-start justify-start">
              <h3 className="font-semibold">Are you still there?</h3>
              <p>Logging out in {remaining} seconds</p>
            </div>
            <div className="flex justify-end gap-4 pt-10">
              <Button
                size="sm"
                className="ltr:mr-2 rtl:ml-2"
                onClick={() => {
                  setIsOpen(false);
                  navigate(routes.logout());
                }}
              >
                Logout Now
              </Button>
              <Button size="sm" variant="secondary" onClick={handleStillHere}>
                Stay Logged In
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SessionTimeout;
